import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgencySnapshotRoutingModule } from './agency-snapshot-routing.module';
import { AgencySnapshotComponent } from './agency-snapshot.component';
import { SnapshotModule } from '../snapshot/snapshot.module';

@NgModule({
  imports: [
    CommonModule,
    AgencySnapshotRoutingModule,
    SnapshotModule
  ],
  declarations: [
    AgencySnapshotComponent
  ],
  providers: [],
  exports: []
})
export class AgencySnapshotModule {}
